import { Routes } from '@angular/router';
import { AuthorizationGuard } from '@softline/auth';

export const deliveryNoteProcessingRoutes: Routes = [
  {
    path: 'delivery-note-processing',
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/main/main.component'),
      },
    ],
    canActivate: [AuthorizationGuard],
    data: { permission: 'SOFTAPPS.DELIVERY_NOTE_EDIT' },
  },
];
